import React, { useState } from 'react';
import { Card, Button, Form, Dimmer } from "tabler-react";
import { useFetch } from '../../../lib/useFetch';
import PutObject from '../../../lib/putObject';
import ImageUpload from '../../../components/imageUpload';

const CityEditModal = ({ recordId, closeMainModal, reload }) => {
  const { data: city, loading: cityLoading, handleChange } = useFetch(`cities/${recordId}`);
  const [saveLoading, setSaveLoading] = useState(false);
  const [error, setError] = useState('');
  const [photoChange, setPhotoChange] = useState(null); // null=unchanged, ''=removed, '<base64>'=new

  const validateForm = () => {
    if (!city?.name) {
      setError('Please enter city name');
      return false;
    }
    if (!city?.cityCode) {
      setError('Please enter city code');
      return false;
    }
    return true;
  };

  const saveEdit = async () => {
    setError('');
    if (!validateForm()) return;

    try {
      setSaveLoading(true);

      const editedCity = {
        _id: recordId,
        name: city.name,
        cityCode: city.cityCode,
      };

      if (photoChange !== null) {
        editedCity.photo = photoChange;
      }

      await PutObject('cities', editedCity);

      if (typeof reload === 'function') {
        reload();
      }
      closeMainModal();
    } catch (err) {
      setError('Failed to update city. Please try again.');
    } finally {
      setSaveLoading(false);
    }
  };

  return (
    <Card>
      <Dimmer active={cityLoading} loader={cityLoading}>
        <Card.Header>
          <Card.Title>Edit City</Card.Title>
          <Card.Options>
            <Button size="sm" icon="x" onClick={closeMainModal} />
          </Card.Options>
        </Card.Header>
        {!cityLoading && city && (
          <>
            <Card.Body>
              {error && <div className="alert alert-danger">{error}</div>}
              <Form onSubmit={(e) => { e.preventDefault(); saveEdit(); }}>
                <Form.FieldSet>
                  <ImageUpload
                    label="Photo"
                    initialUrl={city?.photo}
                    uploadText="Click here to upload city photo"
                    alt="City Preview"
                    onChange={(value) => setPhotoChange(value)}
                  />

                  <Form.Input
                    name='name'
                    label='Name'
                    placeholder='Enter city name'
                    value={city['name'] || ''}
                    onChange={handleChange}
                    required
                  />

                  <Form.Input
                    name='cityCode'
                    label='City Code'
                    placeholder='Enter city code (ex. CAI, JED, RUH)'
                    value={city['cityCode'] || ''}
                    onChange={handleChange}
                    required
                  />
                </Form.FieldSet>
              </Form>
            </Card.Body>
            <Card.Footer>
              <div style={{ textAlign: 'right' }}>
                <Button
                  color="primary"
                  size="sm"
                  className={`ml-2 ${saveLoading ? 'btn-loading' : ''}`}
                  onClick={saveEdit}
                  disabled={saveLoading}
                >
                  Save Changes
                </Button>
                <Button
                  color="secondary"
                  size="sm"
                  className="ml-2"
                  onClick={closeMainModal}
                  disabled={saveLoading}
                >
                  Cancel
                </Button>
              </div>
            </Card.Footer>
          </>
        )}
      </Dimmer>
    </Card>
  );
};

export default CityEditModal;
